import {DefaultResType} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";
import {
    DeadlineFilterItemType,
    DeadlineListElementType,
    DeadlineSaveExchangeElementType,
    DeadlineSearchParamType
} from "../../pages/order/deadline/list/interface";

const url = "api/order/deadline/";

export async function readDeadlineList(data: DeadlineSearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_deadline_list", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function readTaxEndDate(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_tax_end_date");
    } catch (err: any) {
        return err?.response;
    }
}

export async function saveTaxEndDate(data: DeadlineFilterItemType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "save_tax_end_date", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function saveDeadlineExchange(data: DeadlineSaveExchangeElementType[]): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "save_deadline_exchange", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function updateDeadlineProgress(data: DeadlineListElementType[]): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "update_deadline_progress", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function issueTax(data: DeadlineListElementType[]): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "issue_tax", data);
    } catch (err: any) {
        return err?.response;
    }
}

// 내부수정: 세금계산서 개별발행
export async function issueTaxIndividual(data: DeadlineListElementType[]): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "issue_tax_individual", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function exportDeadlineExcel(data: DeadlineSearchParamType): Promise<Blob | ArrayBuffer | Uint8Array | string > {
    const response = await baseApi.post(url + "export_deadline_excel", data, {
        responseType: "blob",
    });
    return response?.data;
}
